module.exports = __webpack_public_path__ + "img/bainianjiajianhualogo.31d3c381.png";